<template>
  <router-link v-if="linkRoute"
               :to="{name: linkRoute.name, query: linkRoute.query}"
               class="link"
               @click="onClick()"
               :data-cy="cypressName"
               :class="{['link--' + modifier]: modifier, 'link--full-width': fullWidth, 'link--button': isButton, 'link--disabled': disabled, 'standard-link': !isButton && !nonStandardLink}">
        <span class="vf-icon"
              :class="{[icon]: !!icon}"
              v-if="icon">
        </span>
        <div class="icon-url"
              v-if="iconClass"
              :aria-label="iconAltText"
              role="img"
              :class="iconClass"></div>
        <span class="label-url"
              v-html="label"></span>
  </router-link>
  <a v-else
     :href="link"
     class="link"
     @click="onClick()"
     :data-cy="cypressName"
     :class="{['link--' + modifier]: modifier, 'link--full-width': fullWidth, 'link--button': isButton, 'link--disabled': disabled, 'standard-link': !isButton && !nonStandardLink}"
     :target="newTab ? '_blank' : undefined">
    <span class="vf-icon"
          :class="{[icon]: !!icon}"
          :aria-label="iconAltText"
          role="img"
          v-if="icon">
    </span>
    <div class="icon-url"
         v-if="iconClass"
         :aria-label="iconAltText"
         role="img"
         :class="iconClass"></div>
    <span class="label-url"
          v-html="label"></span>
  </a>
</template>
<script>
import CsoRouter from '@/api/CsoRouter'

export default {
  name: 'CsoLink',
  props: {
    label: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    iconAltText: {
      type: String,
      required: false,
      default: ''
    },
    iconClass: {
      type: String,
      required: false
    },
    modifier: {
      type: String,
      required: false
    },
    fullWidth: {
      type: Boolean,
      required: false
    },
    newTab: {
      type: Boolean,
      required: false,
      default: false
    },
    newExternalTab: {
      type: Boolean,
      required: false,
      default: false
    },
    isButton: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    cypressName: {
      type: String,
      required: false
    },
    nonStandardLink: {
      type: Boolean,
      default: false
    }
  },

  emits: ['click'],

  computed: {
    linkRoute () {
      return CsoRouter.findInRoutes(this.link)
    }
  },
  data () {
    return {
      CsoRouter
    }
  },
  methods: {
    onClick () {
      if (this.newExternalTab) {
        window.ksoNewTab = window.open('about:blank', '_blank')
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
.link {
  outline: none;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &--full-width {
    display: block;
    width: 100%;
  }

  &--navigation {
    display: grid;
    grid-template-columns: 1fr 5fr;
    width: 100%;
  }

  &--button {
    display: inline-block;
    color: $black;
    font-size: 16px;
    line-height: 42px;
    min-height: 42px;
    padding: 0px 24px;
    text-align: center;
    border-width: 1px;
    border-style: solid;
    border-radius: 100px;
    min-width: 188px;
    outline: none;
    text-decoration: none;
    background-color: $yellow;
    border: 1px solid $yellow;

    &:active {
      background-color: $yellow-dark;
      border-color: $yellow-dark;
    }

    &:hover {
      background-color: $yellow-pale;
      border-color: $yellow-pale;
      text-decoration: none;
    }

    &:focus {
      outline: 2px solid $blue;
      outline-offset: 4px;
    }

    .vf-icon {
      line-height: 12px;
    }
  }

  &--light-white {
    background-color: rgba(0,0,0,0);
    border: 1px solid $black;
    color: $black;

    &.button--disabled[disabled] {
      background-color: $gray-f2;
      border: 1px solid $gray-f2;
      color: $gray-dark;
    }

    &:active,
    &.active {
      background-color: $gray-darker;
      border-color: $gray-darker;
      color: $white;
    }

    &:hover {
      background-color: $black;
      border-color: $black;
      color: $white;
    }
  }

  &--disabled {
    color: $gray-light;

    &:hover {
      cursor: not-allowed;
      text-decoration: none;
    }
  }

  .vf-icon {
    font-size: 20px;
    position: relative;
    top: 5px;
    left: -5px;
  }

  .icon-url {
    display: inline-block;
    height: 24px;
    width: 24px;
    margin-right: 12px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: transparent;
  }

  .home {
    background-image: url('/static/icons/home.svg');
  }

  .user {
    background-image: url('/static/icons/user.svg');
  }

  .account {
    background-image: url('/static/icons/euro.svg');
  }

  .consumption {
    background-image: url('/static/icons/chart.svg');
  }

  .contract {
    background-image: url('/static/icons/contract.svg');
  }

  .tell-a-friend {
    background-image: url('/static/icons/thumbs.svg');
  }

  .help {
    background-image: url('/static/icons/help.svg');
  }

  .faq {
    background-image: url('/static/icons/faq.svg');
  }

  span.label-url {
    font-family: $font-family-regular;
    margin: 0;
  }
}
</style>
